import { store } from "quasar/wrappers";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import md5 from "js-md5";

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store((/* { ssrContext } */) => {
  const pinia = createPinia();

  pinia.use(
    createPersistedState({
      auto: true,
      key: (id) => {
        return md5(id);
      },
      storage: sessionStorage,
      serializer: {
        serialize: (value) => {
          let encryptor = require("simple-encryptor")(process.env.VUEX_KEY);
          return encryptor.encrypt(JSON.stringify(value));
        },
        deserialize: (value) => {
          let encryptor = require("simple-encryptor")(process.env.VUEX_KEY);
          return JSON.parse(encryptor.decrypt(value));
        },
      },
    })
  );

  return pinia;
});
